import { AntragDtoModel } from '@ebeihilfe/core';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const applicationsListActions = createActionGroup({
  source: 'Applications List',
  events: {
    'Load': emptyProps(),
    'Load success': props<{ applicationsList: AntragDtoModel[] }>(),
    'Load failed': props<{ error: Error }>(),
    'Clear store': emptyProps(),
  },
});
